import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '@shared/components/popover/tooltip';
import type { ReactNode } from 'react';

type HeaderGlossProps = {
  /** Plain-language explanation surfaced on hover or focus. */
  gloss: ReactNode;
};

/**
 * Info-icon button for a table column header. Rendered into the header cell's
 * meta-row (see table.tsx) next to the sort indicator — never inside the label's
 * box, so it cannot collide with a wrapping multi-line label. The gloss text is
 * declared as the column's `gloss` metadata; the table renders this for any
 * column that has it.
 */
export function HeaderGloss({ gloss }: HeaderGlossProps) {
  return (
    <Tooltip content={gloss}>
      <button
        type="button"
        aria-label="Column description"
        className="inline-flex shrink-0 items-center justify-center rounded text-gray-400 hover:bg-gray-100 hover:text-gray-600 focus:outline-none focus-visible:ring-1 focus-visible:ring-inset focus-visible:ring-primary-600"
      >
        <InformationCircleIcon className="h-3.5 w-3.5" aria-hidden="true" />
      </button>
    </Tooltip>
  );
}
